import BaseGetters from '@/store/base/getters'
import TimekeepingGetters from '@/store/base/timekeeping/getters'
// import {userCan} from "@/helpers/formatters";

export default BaseGetters({
  getInputData: (state, getters, rootState, rootGetters) => key => state[rootGetters['form/getFormAction'] === 'assignModel' ? 'assignFormData' : 'formData'][key],
  // getFilteredAbsences: (state, getters) => getters['getAbsences'].filter(({personnel_only}) => personnel_only ? userCan('select-personnel-markings') : true),
  getFilteredAbsences: (state, getters) => getters['getAbsences'],
}, [TimekeepingGetters])